import { Box, FormHelperText, Typography } from "@mui/material";

import { trackEvent } from "utils/tracking";

import styles from "./styles";

const ProSuccessCard = () => {
  return (
    <Box sx={styles.cardBg}>
      <Typography variant="h4" sx={{ color: "yellow.main" }} gutterBottom>
        Want Personalized Help?
      </Typography>

      <Typography sx={{ color: "#ECEAE5", mb: 2 }}>
        As a paid subscriber, you get access to our{" "}
        <strong>Customer Success Team</strong>. We'll run a diagnostic on your
        account and you give clear, actionable recommendations to help improve
        your success rate.
      </Typography>

      <Typography sx={{ color: "#ECEAE5" }}>
        👉 Email{" "}
        <a
          rel="noreferrer"
          target="_blank"
          href="mailto:success@onbento.com"
          style={{ color: "white" }}
          onClick={() => trackEvent("Pro Success Card Email Clicked")}
        >
          <strong>success@onbento.com</strong>
        </a>{" "}
        to get started!
      </Typography>

      <FormHelperText sx={{ color: "purple.main", mt: 2 }}>
        Please allow up to 5 business days for a response.
      </FormHelperText>
    </Box>
  );
};

export default ProSuccessCard;
